'use client';

import { useCallback, useRef, useState } from 'react';
import { flushSync } from 'react-dom';

export function useContextMenuTarget() {
  const [contextMenuTarget, setContextMenuTarget] = useState(null);
  const hasContextMenuRef = useRef(false);

  const registerContextMenu = useCallback((hasMenu: boolean) => {
    hasContextMenuRef.current = hasMenu;
  }, []);

  return {
    contextMenuContext: {
      target: contextMenuTarget,
      setContextMenuTarget,
      registerContextMenu,
    },
    contextMenuProps: {
      onContextMenu: (e: React.MouseEvent) => {
        if (contextMenuTarget) {
          flushSync(() => {
            setContextMenuTarget(null);
          });
        }

        if (hasContextMenuRef.current) {
          e.preventDefault();
          const x = e.clientX;
          const y = e.clientY;

          setContextMenuTarget({
            // @ts-expect-error FIXME(strictNullChecks)
            getBoundingClientRect: () => ({
              width: 0,
              height: 0,
              left: x,
              right: x,
              top: y,
              bottom: y,
              x,
              y,
            }),
          });
        }
      },
    },
  };
}
